/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";
import {  } from "relay-runtime";
export type PdpRespContainer_shipmentQuote = {
    readonly " $fragmentRefs": FragmentRefs<"PdpRespSidebarBlurbs_shipmentQuote" | "PdpRespShippingReturns_shipmentQuote">;
    readonly " $refType": "PdpRespContainer_shipmentQuote";
};
export type PdpRespContainer_shipmentQuote$data = PdpRespContainer_shipmentQuote;
export type PdpRespContainer_shipmentQuote$key = {
    readonly " $data"?: PdpRespContainer_shipmentQuote$data | undefined;
    readonly " $fragmentRefs": FragmentRefs<"PdpRespContainer_shipmentQuote">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpRespContainer_shipmentQuote",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpRespSidebarBlurbs_shipmentQuote"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpRespShippingReturns_shipmentQuote"
    }
  ],
  "type": "ShipmentQuote",
  "abstractKey": null
};
(node as any).hash = 'efb9d699ed292459b86b63bb220d8246';
export default node;
